import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@lifeomic/chroma-react/styles';
import { colorModeSelectors } from '../../redux/modules/colorMode';
import { createPhcTheme } from '../../theme/phc';

export type PhcThemeProviderProps = {
  children: React.ReactNode;
};

const PhcThemeProvider: React.FC<PhcThemeProviderProps> = ({ children }) => {
  const colorMode = useSelector(colorModeSelectors.selectColorMode);
  const theme = useMemo(() => createPhcTheme(colorMode), [colorMode]);

  useEffect(() => {
    document.documentElement.dataset.phcColorMode = colorMode;
    document.documentElement.style.colorScheme = colorMode;
  }, [colorMode]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default PhcThemeProvider;
